import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=ed83d268&scoped=true"
import script from "./AI.vue?vue&type=script&lang=ts"
export * from "./AI.vue?vue&type=script&lang=ts"
import style0 from "./AI.vue?vue&type=style&index=0&id=ed83d268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed83d268",
  null
  
)

export default component.exports